<template>
  <Header @hamburger-click="focus = !focus" />

  <Hero photo="level_up-WEB_2.jpg" :class="{ focus: true, 'focus--hide': focus }" />
  <Text
    heading="Sinds 1996"
    subtitle="We’ve come a long way..."
    :white="true"
    id="wat-doen-wij"
    :class="{ focus: true, 'focus--hide': focus }" 
  >
    <p>
      <a href="https://www.tnt.be" title="Tallieu & Tallieu" target="_blank">Tallieu & Tallieu</a>
       is een creatieve studio voor no-nonsense klanten.<br/>Wij maken websites sinds 1996!
    </p>
    <p>
      Van de statische HTML pagina's van toen naar CMS gestuurde responsive websites, e-shops en complexe webapps vandaag.<br />
      Dit alles op basis van ons eigen custom MVC framework, VueJS, Laravel, … 
    </p>
  </Text>

  <Photo src="photo-01.png" :class="{ focus: true, 'focus--hide': focus }" />

  <Text
    heading="Wat doen wij?"
    subtitle="Géén Squarespace, Drupal of Wordpress"
    :class="{ focus: true, 'focus--hide': focus }"
  >
    <p>
      Met ons eigen PHP-framework en Laravel stemmen we webprojecten volledig af op de wensen van onze klanten.
      </p>
      <p>
      Ons framework en CMS is voortdurend in ontwikkeling, dankzij de noden van onze klanten.
      Vandaar dat klanten zoals o.a. <a href="https://www.democrazy.be/" target="_blank" title="Democrazy"
        >Democrazy</a
      >, <a  href="https://www.n9.be/" target="_blank" title="Democrazy">N9</a>, <a  href="https://www.musicmaniarecords.be/" target="_blank" title="Music Mania Records">Music Mania Records</a>, <a
        href="https://morleyforkids.be/"
        target="_blank"
        title="Morley Pro Application"
        >Morley</a
      >, <a href="https://mijn.veroniquesneyaert.be/" target="_blank" title="Veronique"
        >Veronique</a>, 
              <a
        href="https://www.the-aviation-factory.com/"
        title="The Aviation Factory"
        target="_blank"
        >The Aviation Factory</a
      > en <a href="https://www.mustmove.be/" target="_blank" title="Mustmove"
        >Mustmove</a
      > bewust voor ons kiezen voor de ontwikkeling van hun webprojecten.
    </p>

    <p>
      Ontdek 
      <a href="https://www.tnt.be/cases/" target="_blank" rel="noopener noreferer">
      onze cases 
      </a>
      en 
      <a href="https://www.tnt.be/the-wall/" target="_blank" rel="noopener noreferer">
      onze portfolio</a>!
    </p>
  </Text>

  <Photo
    src="elckerlijc.jpg"
    :fixed="true"
    :class="{ focus: true, 'focus--hide': focus }"
  />
  <Photo
    src="mawyc.jpg"
    :fixed="true"
    :class="{ focus: true, 'focus--hide': focus }"
  />

  <Text
    heading="Wat doen wij?"
    subtitle="We do a lot!"
    :white="true"
    :class="{ focus: true, 'focus--hide': focus }"
  >
    <p>
      E-commerce, online stock systemen, booking applicaties, API-ontwikkeling, presentatie websites, e-mailings, ...<br />Met oog voor detail en passie voor het web.
    </p>
    <p>
      Onze aanpak is eigenwijs: wat we beter kunnen, doen we zelf. We bijten ons vast tot we het verschil maken.
    </p>
  </Text>

  <Photo
    src="pringels.jpg"
    :fixed="true"
    :class="{ focus: true, 'focus--hide': focus }"
  />
  <Photo
    src="n9.jpg"
    :fixed="true"
    :class="{ focus: true, 'focus--hide': focus }"
  />

  <Text
    heading="Wie zoeken wij?"
    subtitle="Iemand met passie voor het web en de techniek erachter"
    id="wie-zoeken-wij"
    :full="true"
    :class="{ focus: true, 'focus--hide': focus }"
  >
    <Column>
      <div class="column">
        <Title headingType="h3" title="Medior / Senior functie"/>
        <ul>
          <li>Uitgebreide kennis van PHP – HTML – (S)CSS – JavaScript</li>
          <li>Ervaring met MVC frameworks en API's</li>
          <li>Basiskennis van Laravel, VueJS en/of React. Of gemotiveerd om jouw kennis uit te breiden</li>
          <li>GIT en Docker kent geen geheimen voor jou</li>
          <li>Je spreek vloeiend Nederlands en Engels</li>
          <li>Je woont in de regio</li>
        </ul>
      </div>
      <div class="column">
        <Title headingType="h3" title="Extra pluspunten" />
        <ul>
          <li>Ervaring in gebruik van Claude CLI of andere AI programming tools</li>
          <li>Kennis van programma’s zoals: Figma, Illustrator, Photoshop, After Effects…</li>
          <li>Ervaring of interesse in het ontwerpen van websites</li>
          <li>Kennis van SEO</li>
        </ul>
      </div>
    </Column>
  </Text>

  <Photo src="TNT_Vacature_0-1.jpg" :class="{ focus: true, 'focus--hide': focus }" />
  <!-- <Photo src="mm2." :class="{ focus: true, 'focus--hide': focus }" />s -->
  
  <Photo
    src="TNT_Vacature_0-4.webp"
    :fixed="true"
    :class="{ focus: true, 'focus--hide': focus }"
  />
  <img src="./assets/img/photo-04-1.jpg" style="display:block; width:100%;" :class="{ focus: true, 'focus--hide': focus }">

  <Text
    heading="Wat bieden wij?"
    footer="Kwaliteit boven buzzwords, al meer dan 40 jaar lang"
    id="wat-bieden-wij"
    :white="true"
    :class="{ focus: true, 'focus--hide': focus }"
  >
    <Column>
      <div class="column">
        <ul>
          <li>
            Uitdagende en vaste job in een jong gemotiveerd team
          </li>
          <li>Gevarieerde opdrachten in front- en backend</li>
          <li>Aangename werkomgeving en werksfeer</li>
          <li>Nauwe samenwerking met de collega's</li>
          <li>38 uren week met 1 vaste thuiswerkdag op vrijdag</li>
        </ul>
      </div>
      <div class="column">
        <ul>
          <li>Ruimte om jouw kennis & skills verder te ontwikkelen</li>
          <li>Stabiel bedrijf met een uitgebreide technische kennis</li>
          <li>Marktconforme verloning</li>
          <li>Nieuw kantoor naast het domein Jozef Guislain in Gent</li>
        </ul>
      </div>
    </Column>
  </Text>

  <Photo src="TNT_Vacature_0-2.webp" :class="{ focus: true, 'focus--hide': focus }" />

  <Text
    heading="Interesse?"
    footer="Aarzel niet om te solliciteren!"
    id="interesse"
    :class="{ focus: true, 'focus--hide': focus }"
  >
    <p>
      Stuur je sollicitatiebrief met volledige C.V. naar ons kantoor t.a.v. Jana
      Tallieu:
    </p>
    <p>
      <a
        href="mailto:wewantyou@tnt.be"
        title="Stuur je sollicitatiebrief naar wewantyou@tnt.be"
        >wewantyou@tnt.be</a
      >
    </p>
    <p>PS: Je kandidatuur wordt discreet behandeld.</p>
  </Text>
  <Footer :class="{ focus: true, 'focus--hide': focus }" />
</template>

<script>
import Header from "@/components/Header.vue";
import Hero from "@/components/Hero.vue";
import Text from "@/components/Text.vue";
import Photo from "@/components/Photo.vue";
import Column from "@/components/Column.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "WeWantYou",
  base:"./",
  components: {
    Header,
    Hero,
    Text,
    Photo,
    Column,
    Footer,
  },
  data() {
    return {
      focus: false,
    };
  },
};
</script>
<style lang="scss">
@import "./assets/mixins.scss";
/* Title */
@font-face {
  font-family: 'Quablo';
  src: url('./assets/fonts/Quablo-Medium.eot');
  src: url('./assets/fonts/Quablo-Medium.eot?#iefix') format('embedded-opentype'),
       url('./assets/fonts/Quablo-Medium.woff2') format('woff2'),
       url('./assets/fonts/Quablo-Medium.woff') format('woff'),
       url('./assets/fonts/Quablo-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap; /* optional, improves performance */
}


.column {
  margin: 3em 0;
  h3 {
    margin-bottom: 1rem;
  }
  ul {
      list-style-position: inside;
       padding-left: 1rem;
  }
  @include mq(lg) {
    margin: unset;
  }
}

#app {
  // scroll-snap-type: y proximity;
  overflow-y: scroll;
  height: 100%;
  height: 100vh;
}

.focus {
  opacity: 1;
  transition: opacity 300ms ease-in-out, filter 300ms ease-in-out;

  &--hide {
    opacity: 0.2;
    filter: blur(5px);
    @include mq(lg){
        opacity: unset;
        filter: unset;
    }
  }
}

</style>
